import React, { Component } from 'react';
import AuthorAbout from '/components/AuthorProfile/AuthorAbout';
import AuthorTabs from '/components/AuthorProfile/AuthorTabs';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {fetchAuthorProfile, fetchAuthorVideos, fetchAuthorArticles } from "store/posts/actions";
import {bindActionCreators} from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Store from "store";
import MobileNewsItem from "/components/Mobile/MobileNewsItem";
import DesktopNewsItem from "/components/Desktop/DesktopNewsItem";
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { isMobile } from "react-device-detect";
import Axios from "/plugins/axios";
// import TagManager from 'react-gtm-module';
import SeoMeta from '/components/seoMeta';
import Head from "next/head";
import NProgress from "components/NProgress";

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }
const styles = theme => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing.unit * 2,
      margin: 'auto',
      maxWidth: 500,
    },
    customCard: {
        boxShadow: 'none'
    },
    layout: {
        marginLeft: 'auto',
        marginRight: 'auto',
          [theme.breakpoints.up('md')]: {
            width: 1140,
            maxWidth: 1140,
          },
          [theme.breakpoints.only('md')]: {
            width: '100%',
          },
          [theme.breakpoints.only('sm')]: {
            width: 650
          },
    },
    
  })
  
class AuthorProfile extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            newsItems: [],
            videoItems: [],
            isLoading: true,
            next: this.props.authorArticlesLinks.next,
            nextVideos: this.props.authorVideosLinks.next,
            url: this.props.url,
            open: false
         }
    }
    static async getInitialProps({store, query, asPath, isServer, res}) {
        const { id } = query;
        // function numOrConcatMail(id) {
        //   if (isNaN(id)) {
        //     return id.concat('@duwun.com.mm').toLowerCase();
        //   }
        //   return id;
        // }
        let _id = id.toLowerCase();
        const currentDateTime = new Date().toISOString();
        await store.execSagaTasks(isServer, dispatch => {
          dispatch(fetchAuthorProfile(_id));
          dispatch(fetchAuthorVideos(_id, currentDateTime, 8));
          dispatch(fetchAuthorArticles(_id, currentDateTime, 8));            
        });
        // await store.execSagaTasks(isServer, dispatch => {
        //     store.dispatch(fetchAuthorVideos(_id, currentDateTime, 8));
        //     store.dispatch(fetchAuthorArticles(_id, currentDateTime, 8));   
        // });
        if(!store.getState().posts.authorProfile) {
          console.log("store.getState().posts")
          console.log(store.getState().posts);
          res.statusCode = store.getState().posts.error.status || 404;
        }
        return { _id, asPath, isServer, currentDateTime};   
    }
    nextVideoPage = (url) => {
        // const nextPerPage = isMobile ? 6 : 4
        url = `/authors/${this.props._id}/videos?perPage=8&published_date=${this.props.currentDateTime}&exclude=body${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
        this.setState({ 
            loading: true
         });
        Axios.get(url)
            .then(res => {
                res.data.data.map((value) => this.state.videoItems.push(value))
            
                this.setState({
                    isLoading: false,
                    videoItems: this.state.videoItems,
                    nextVideos: res.data.links.next,
                    loading: false,
                })
            })
    }
    __nextVideoBtn () {
        const {classes, uniReadable} = this.props;
       
        if(this.state.nextVideos != null) {
            return (
              <div style={{textAlign: 'center', paddingBottom: 16}}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => !this.state.loading ? this.nextVideoPage(this.state.nextVideos) : null}
                >
                    <span>
                        {
                            uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                        }
                    </span>
                  {this.state.loading ? 
                    <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                        : 
                    <div style={{display: 'inline-flex'}}>
                      <Icon>keyboard_arrow_down</Icon>
                    </div> 
                     }
                </Button>
                
              </div>
            )
        }
    }
    
    nextPage = (url) => {
        const nextPerPage = isMobile ? 6 : 8
        url = `/authors/${this.props._id}/articles?published_date=${this.props.currentDateTime}&perPage=${nextPerPage}&exclude=body${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
        this.setState({ 
            loading: true
         });
        Axios.get(url)
            .then(res => {
                res.data.data.map((value) => this.state.newsItems.push(value))
                this.setState({
                    isLoading: false,
                    newsItems: this.state.newsItems,
                    next: res.data.links.next,
                    loading: false,
                })
            })
    }
     __nextBtn () {
        const {classes, uniReadable} = this.props;
        if(this.state.next != null) {
            return (
              <div style={{textAlign: 'center', paddingBottom: 16}}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => !this.state.loading ? this.nextPage(this.state.next) : null}
                >
                    <span>
                        {
                            uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                        }
                    </span>
                  {this.state.loading ? 
                    <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                        : 
                    <div style={{display: 'inline-flex'}}>
                      <Icon>keyboard_arrow_down</Icon>
                    </div> 
                     }
                </Button>
                
              </div>
            )
        }
    }
    toggle = () => {
      this.setState(state => ({ open: !state.open }));
    };

    render() { 
        const { classes, asPath, _id, authorProfile, authorArticles, authorArticlesLinks, authorVideos, authorVideosLinks } = this.props;
        let { newsItems, videoItems } = this.state;
        let nextPageItemsMobile = newsItems && newsItems.map((newsItem, index) => (
            <React.Fragment key={index}>
              <MobileNewsItem key={index} item={newsItem} />
            </React.Fragment>
              ))
          let nextPageItemsDesktop =  <Grid container style={{marginBottom: 15}}>
          {newsItems && newsItems.map((item, index) => (
              <React.Fragment key={index}>
              <Grid item xs={3}>
                  <DesktopNewsItem item={item}  />
              </Grid>
              </React.Fragment>
                      ))}  
          </Grid>
          const ogImage = authorProfile && authorProfile.profile_cover ? authorProfile.profile_cover : 'https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg';
          const name = authorProfile && authorProfile.name ? authorProfile.name : 'author';
          const title = authorProfile && authorProfile.title ? authorProfile.title : '';
          const description = authorProfile && authorProfile.title ? authorProfile.description : '';
        return ( 
            <>
                <Head>
                    <title>{name}</title>
                </Head>   
                <SeoMeta 
                        url={`${process.env.BACKEND_URL}${this.props.asPath}`} 
                        type="article"
                        title={name}
                        description={description}
                        image={ogImage}
                        section={name}
                        keywords={`${name}, ${title}, author`}
                    />                       
                <NProgress />
                <div className={classes.layout} 
                style={{ 
                    marginLeft: 'auto',
                    marginRight: 'auto', 
                    // paddingBottom: 20
                }}
            >
                <AuthorAbout authorProfile={authorProfile} asPath={asPath} toggleBox={this.toggle} open={this.state.open} />
                <AuthorTabs 
                    articlesCount={authorProfile.article_count}
                    videosCount={authorProfile.video_count}
                    articles={authorArticles}
                    func={this.__nextBtn()}
                    videoNextFunc={this.state.nextVideos ? this.__nextVideoBtn() : null}
                    itemsMobile={nextPageItemsMobile} 
                    itemsDesktop={nextPageItemsDesktop}
                    authorVideos={authorVideos ? authorVideos : null}
                    newsItems={newsItems}
                    videoItems={videoItems}
                    mobileMaxNum='6'
                    asPath={asPath}
                />
                </div>
        
            </>
        );
    }
    componentDidMount () {

    }
    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)
    }
}
const mapStateToProps = state => ({
    authorProfile: state.posts.authorProfile.data,
    authorArticles: state.posts.authorArticles.data,
    authorArticlesLinks: state.posts.authorArticles.links,
    authorVideos: state.posts.authorVideos.data,
    authorVideosLinks: state.posts.authorVideos.links,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchAuthorProfile,
    fetchAuthorVideos,
    fetchAuthorArticles,
}, dispatch);

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(withReduxSaga(withStyles(styles)(AuthorProfile)));
